// extracted by mini-css-extract-plugin
export default {"ImageSmall":"CaptureEcran_ImageSmall__1GONh","ImageLarge":"CaptureEcran_ImageLarge__QsEjd","Url":"CaptureEcran_Url__nlZ+N"};